//------------------------------------------------------------------------
// Mobile nav toggle
//------------------------------------------------------------------------
// Note: For some reason, the compiled JS causes a Webpack error:
//   “Uncaught TypeError: Getter must be a function: d”
// so we’re using the uncompiled source code.
import ExpandToggle from "@threespot/expand-toggle/index";

export default class SearchToggle {
  constructor(selector) {
    this.el = document.querySelector(selector);

    if (!this.el) {
      console.warn(
        `Unable to initialize nav toggle, no matching element for “${selector}”`
      );
      return false;
    }

    this.resetEvent = new CustomEvent("nav-reset"); // used to close subnav menus
    this.init();

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".Header-search")) {
        this.searchToggle.collapse();
      }
    });
  }

  init() {
    this.searchToggle = new ExpandToggle(this.el);
    this.searchToggle.on("expand", () => {
      document.querySelector("#query").focus();
    });
  }

  destroy() {
    this.searchToggle.destroy();
  }
}

new SearchToggle('[data-expands="search"]');



// WEBPACK FOOTER //
// ./scripts/modules/search-toggle.js